import React from 'react';
import classnames from 'classnames';
import s from './BulletItem.scss';
const BulletItem = ({ bullet, children, className, textClassName })=>/*#__PURE__*/ React.createElement("li", {
        className: classnames(s['item'], className)
    }, bullet && /*#__PURE__*/ React.createElement("span", {
        className: s['bullet'],
        "aria-hidden": true
    }, bullet), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['text'], textClassName)
    }, children));
BulletItem.displayName = 'IconBullet';
export default BulletItem;
